// extracted by mini-css-extract-plugin
export default {"wrapper":"NavBalanceWrapper_wrapper__RA2d7"};